'use strict';

SC.supersoul = (function () {
  var api = {};

  // Testimonials slideshow configuration
  if ($('.swiper-slide').length > 1 && typeof Swiper === 'function') {
    new Swiper('.swiper-container', {  
      a11y: true,
      speed: 1000,
      autoplay: 10000,
      loop: true,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      paginationType: 'bullets',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev'
    });
  }

  /**
   * mParticle sendEvent - Click Buy Series CTA - SuperSoul Landing Page Package Section
   * Sends an mParticle event with GA label
   */
  $('.supersoul__section__package-content-link').click(function () {
    SC.analytics.mp.sendEvent('Click Buy Series CTA', 'navigation', {
      'Location': 'SuperSoul Landing Page Package Section'
    }, 'Navigation');
  });

  /**
   * mParticle sendEvent - Click Buy Series CTA - SuperSoul Landing Page Sign Up Section
   * Sends an mParticle event with GA label
   */
  $('.supersoul__section__signup-content-link').click(function () {
    SC.analytics.mp.sendEvent('Click Buy Series CTA', 'navigation', {
      'Location': 'SuperSoul Landing Page Sign Up Section'
    }, 'Navigation');
  });

  return api;
})();
